<template>
  <div class="myteacher">
    <Header msg='我的班主任' style="border-bottom: 1px solid #eee;"/>
    <!-- <div class="teacher-msg">
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span style="font-weight: bold;">基本信息</span>
                <span></span>
            </div>
        </div>
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>姓名</span>
                <span>{{pageData.name || '---'}}</span>
            </div>
        </div>
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>手机</span>
                <p class="herfPhone"><a :href="'tel:' + pageData.mobile">{{pageData.mobile || '---'}}</a></p>
            </div>
        </div>
    </div> -->

    <div class="Invitation-context">
      <div class="code-bgs">
        <img src="@/assets/recruit/invite_bg01@3x.png" alt="" class="code-bg"/>
        <p class="code-mycode text-yellow">{{pageData.name || '---'}}</p>
        <div class="teacherMsg text-yellow"><p class="herfPhone"><a :href="'tel:' + pageData.mobile">{{pageData.mobile || '---'}}</a></p></div>
        <div class="qrcode">
            <img :src="pageData.wechat_number" alt="" />
        </div>
        <div class="code-bottom">
            <p>长按二维码</p>
            <p>↑↑↑添加您的班主任</p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { MessageBox, Toast } from 'mint-ui';
import { getTeacher } from '@/api';

export default {
  name: 'Teacher',
  components: {
    Header
  },
  data() {
    return {
      pageData: {} // 页面数据
    }
  },
  created() {
    this.getTeacherMsg();
  },
  mounted () {
    // MessageBox.alert('功能完善中...').then(action => {
    //   this.$router.go(-1);
    // });
  },
  methods: {
    // 获取页面数据
    getTeacherMsg() {
      getTeacher().then(res => {
        // if (res.code !== 0) {
        //   Toast({message: res.msg, duration: 1500});
        // }
        this.pageData = res.data || {};
      })
    }
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
// /deep/ .mint-header{
//   border-bottom: 1px solid #eee;
// }
.teacher-msg{
    padding: 0 0.16rem;
    background-color: white;
    // margin-top: 0.1rem;
    font-size: 0.16rem;
    &>:last-child{
        border: none;
    }
}

.Invitation-context{
    // border-top: 0.08rem solid #F6F6FA;
    // padding: 0.3rem 0 0;
    background: white;
    position: relative;
    height: 100vh;
    .code-bgs{
        width: 3.17rem;
        height: 4.3rem;
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .code-bg{
        width: 3.17rem;
        height: 4.3rem;
        position: absolute;
        // top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        // margin-bottom: 0.2rem;
    }
    .code-mycode{
        // color: #121922;
        font-size: 0.2rem;
        position: absolute;
        font-weight: bold;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
    }
    .qrcode{
        width: 2.6rem;
        height: 2.6rem;
        padding: 0.1rem;
        position: absolute;
        top:0.9rem;
        left: 50%;
        transform: translateX(-50%);
        border: 1px solid #eeeeee;
        img{
          width: 100%;
          height: 100%;
        }
    }
    .code-bottom{
        width: 2.4rem;
        line-height: 0.25rem;
        color: #FABF01;
        font-size: 0.14rem;
        position: absolute;
        top: 3.6rem;
        left: 50%;
        transform: translateX(-50%);
    }
    .teacherMsg{
      position: absolute;
      top: 0.6rem;
      left: 50%;
      font-size: 0.16rem;
      transform: translateX(-50%);
    }
    
}
.herfPhone{
  display: inline-block;
  a{
    color: #FABF01;
  }
}
</style> 

